import type { Cart } from '../types/cart';

export function getCart(): Cart {
	const cart = localStorage.getItem('cart');

	if (!cart) return { items: [] };

	try {
		let parsedCart = JSON.parse(cart) as Cart;

		parsedCart = migrateCart(parsedCart);

		localStorage.setItem('cart', JSON.stringify(parsedCart));

		return {
			items: parsedCart.items || [],
			coupon: parsedCart.coupon,
		};
	} catch (err) {
		localStorage.removeItem('cart');
		return { items: [] };
	}
}

function migrateCart(cart: Cart): Cart {
	if (!cart || !Array.isArray(cart.items)) return cart;

	return {
		...cart,
		items: cart.items.map((item) => {
			if (!item.selectedAddOns) return item;

			const migratedAddOns = item.selectedAddOns.map((addOn) => {
				if (addOn.quantities) return addOn;

				const quantities: Record<string, number> = {};

				addOn.selectedOptionIds?.forEach((optionId) => {
					quantities[optionId] = 1;
				});

				return {
					...addOn,
					quantities,
				};
			});

			return {
				...item,
				selectedAddOns: migratedAddOns,
			};
		}),
	};
}
